import React from 'react';
import Moment from 'moment';
import IntlMessages from 'util/IntlMessages';
import UserAvatar from 'components/UserAvatar';
import User from 'components/User';

const getTitle = type => {
	switch (type) {
		case 1:
			return 'meldooWeb.reportDetails.workflow.inserted';
		case 2:
			return 'meldooWeb.reportDetails.workflow.checked';
		case 3:
			return 'meldooWeb.reportDetails.workflow.inWork';
		case 4:
			return 'meldooWeb.reportDetails.workflow.completed';
		default:
			return 'common.undefined';
	}
};

const WorkflowItem = ({ item }) => {
	return (
		<div key={item.id} className="timeline-item">
			<div className="timeline-badge timeline-img rounded-circle border text-dark d-flex align-items-center justify-content-center bg-white">
				<i className="zmdi zmdi-check zmdi-hc-2x" />
			</div>

			<div className="timeline-panel ">
				<div className="timeline-panel-header">
					<div className="timeline-header-img timeline-left">
						<UserAvatar avatar={item.user.avatar} size={60} />
					</div>
					<div className="timeline-heading">
						<h5>
							<strong>
								<User user={item.user} />
							</strong>
							{` am ${Moment(item.date).format('DD.MM.YYYY')} um ${Moment(item.date).format('HH:mm')}`}
						</h5>
						<h3 className="timeline-title">
							<IntlMessages id={getTitle(item.type)} />
						</h3>
					</div>
				</div>
				{item.comment && (
					<div className="timeline-body">
						<p>{item.comment} </p>
					</div>
				)}
			</div>
		</div>
	);
};

export default WorkflowItem;



// WEBPACK FOOTER //
// ./containers/MeldooWeb/Pages/ReportDetails/Component/WorkflowItem.js